import { Component, HostBinding, Input } from '@angular/core'
import { Params } from '@angular/router'

export type WordTickerItem = {
  /** Shown as is - include any punctuation ('mattress.'). */
  text: string
  /** Makes the word a link (only while it's showing). */
  link?: { path: string; queryParams?: Params; title?: string }
}

/**
 * A slot that shows one of several words, sliding the next one in when `index` changes. The parent
 * owns the timing (and the look - put it inside a coloured tag), this owns the rest: every word is
 * in the page, but only the showing one is read out, focusable or clickable, and each word carries
 * a real trailing space so screen readers and crawlers read "Sell your desk." rather than
 * "Sell yourdesk." (Angular drops the whitespace between elements).
 */
@Component({
  selector: 'app-word-ticker',
  templateUrl: './word-ticker.component.html',
  styleUrls: ['./word-ticker.component.css'],
})
export class WordTickerComponent {
  @Input() items: WordTickerItem[] = []

  /** Which word is showing. */
  @Input() index = 0

  /**
   * Always as wide as the longest word, instead of the showing one. Use it when words follow the
   * ticker on the same line - otherwise they shift over each time the width changes.
   */
  @Input() @HostBinding('class.fixed-width') fixedWidth = false
}
